import { useMemo } from "react";
import { useParams } from "react-router";

import { PageContent, PageHeader, TabContent } from "components/layout";
import { tivoAppsApi } from "containers/Request/SRPC/apiClient";

import { TiVoDeviceAppsList } from "./components/TiVoDeviceAppsList";
import { TiVoDeviceTabs } from "./components/TiVoDeviceTabs";
import { getOemTabs } from "./utils";

export function TiVoOemApplications() {
  const { platformId, oemId } = useParams();
  const { data } = tivoAppsApi.getTiVoOem.useQuery(platformId!, oemId!, {
    queryOptions: {
      enabled: Boolean(oemId) && Boolean(platformId),
    },
  });
  const oem = useMemo(() => data?.results, [data?.results]);

  return (
    <>
      <PageHeader>{oem?.name || ""}</PageHeader>
      <PageContent>
        <TiVoDeviceTabs tabs={getOemTabs(platformId, oemId)} />
        <TabContent>
          <TiVoDeviceAppsList
            platformId={platformId!} // We can non-null assert because this parameter is in the path
            oemId={oemId!} // We can non-null assert because this parameter is in the path
          />
        </TabContent>
      </PageContent>
    </>
  );
}
